export default __webpack_public_path__ + "static/media/attendants.7097d6bf.jpg";